'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setLoaderTimeout = exports.disableLoader = exports.updateBuyBarSelected = exports.initProductSpecsDetails = exports.initProductUpsellData = exports.loadFlowForVariants = exports.initFlowData = exports.initProductData = exports.getProductSpecsDetailsData = exports.getProductUpsellsData = exports.getProductData = exports.updateProduct = exports.checkHandle = exports.addAllSlides = exports.getCurrentProductHandle = exports.initProductGallery = exports.productData = undefined;

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

require('slick-carousel');

require('jquery-zoom');

var _Constants = require('common/Constants');

var _Constants2 = _interopRequireDefault(_Constants);

var _Dom = require('common/Dom');

var _Dom2 = _interopRequireDefault(_Dom);

var _Helpers = require('common/Helpers');

var _SeeItStyled = require('../SeeItStyled');

var _SeeItStyled2 = _interopRequireDefault(_SeeItStyled);

var _Remodal = require('../Remodal');

var _Remodal2 = _interopRequireDefault(_Remodal);

var _DataSelector = require('../../common/Class/DataSelector');

var _DataSelector2 = _interopRequireDefault(_DataSelector);

var _SizeGuide = require('../SizeGuide');

var _SizeGuide2 = _interopRequireDefault(_SizeGuide);

var _ProductAvailability = require('components/ProductAvailability');

var _ProductAvailability2 = _interopRequireDefault(_ProductAvailability);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint-disable */

var productData = exports.productData = false;
// import { productData } from 'components/Product/index';

var video = false;
var HTTP_OPTIONS = {
  credentials: 'include',
  headers: {
    'Content-Type': 'application/json'
  }
};

var isParentChild = function isParentChild() {
  return bvaccel.template.alternate === 'parent-child';
};

var initUpsells = function initUpsells(handle) {
  var currentHandle = getCurrentProductHandle();

  if (currentHandle !== handle) {
    if (productData.upsells_ready) {
      var upsellsHTML = productData.children[handle].upsells_html;

      $(_Dom2.default.pdpUpsellsWrapper).html(upsellsHTML);
      _Remodal2.default.init();
    }
  }

  if ($('[data-upsell]').length == 0) {
    $(_Dom2.default.pdpUpsellsWrapper + ', .holiday-gift-box-upsell').hide();

    return;
  }

  // $(dom.pdpUpsells).on('init reInit afterChange', (event, slick) => {
  //   console.log('1');
  //   if (slick.slideCount === 0) {
  //     $(dom.pdpUpsellsWrapper).css('display', 'none');
  //     console.log('2');
  //   } else {
  //     $(dom.pdpUpsellsWrapper).css('display', 'block');
  //     console.log('3');
  //   }
  // });

  $(_Dom2.default.pdpUpsells + ':not(.slick-slider)').slick({
    rows: 0,
    arrows: true,
    slidesToShow: 3,
    infinite: false,
    nextArrow: '<button class="slick-next slick-arrow" aria-label="go to next slide" type="button"><svg class="slick-arrow__icon" width="9" height="14" viewBox="0 0 9 14" xmlns="http://www.w3.org/2000/svg"><path d="M1.6855 0L0 1.63333 5.53808 7 0 12.36667 1.6855 14l7.22359-7z" fill="#2B2B2B" fill-rule="evenodd"/></svg></button>',
    prevArrow: '<button class="slick-prev slick-arrow" aria-label="go to previous slide" type="button"><svg class="slick-arrow__icon" width="9" height="14" viewBox="0 0 9 14" xmlns="http://www.w3.org/2000/svg"><path d="M7.22359 0l1.6855 1.63333L3.37101 7l5.53808 5.36667L7.22359 14l-7.2236-7z" fill="#2B2B2B" fill-rule="evenodd"/></svg></button>'
  });

  _ProductAvailability2.default.initUpsells();
};

var getSlickOption = function getSlickOption(option) {
  return $(_Dom2.default.pdpImageGallery).slick('slickGetOption', option);
};

var filterSlider = function filterSlider(filter) {
  var isFiltered = $(_Dom2.default.pdpImageGallery).hasClass('is-filtered');

  if (isFiltered) {
    $(_Dom2.default.pdpImageGallery).slick('slickUnfilter');
  }

  var $filteredSlides = $(_Dom2.default.pdpImageGallery).find('[data-filter-tag~="' + filter + '"]');

  if ($filteredSlides.length) {
    $(_Dom2.default.pdpImageGallery).addClass('is-filtered');
    var items = $(_Dom2.default.pdpImageGallery).slick('slickFilter', '[data-filter-tag~="' + filter + '"]');
  }
};

var updateUrlHistory = function updateUrlHistory(handle) {

  if (!isParentChild() && location.search.length) {
    var urlParams = new URLSearchParams(window.location.search);
    var strapColor = urlParams.get('strap-color');

    if (strapColor) {
      // Strip out the strap-color param from URL
      var _paths = window.location.pathname.split('/');

      _paths[_paths.length - 1].indexOf('collection_') >= 0 ? _paths[_paths.length - 2] = handle : _paths[_paths.length - 1] = handle;
      _paths = _paths.join('/');
      var _url = window.location.protocol + '//' + window.location.host + _paths;

      window.history.replaceState({}, document.title, _url);

      $(_Dom2.default.optionValue + '[data-value=' + strapColor + ']').trigger('click');
    }
  }

  if (!isParentChild()) {
    return;
  }

  var currentTitle = document.title.split(' – ');
  var title = productData.children[handle].data.title + ' \u2013 ' + currentTitle[1];
  var paths = window.location.pathname.split('/');

  paths[paths.length - 1].indexOf('collection_') >= 0 ? paths[paths.length - 2] = handle : paths[paths.length - 1] = handle;
  paths = paths.join('/');
  var url = window.location.protocol + '//' + window.location.host + paths + window.location.search;

  window.history.replaceState({}, title, url);
  document.title = title;
};

/**
 * Fills the variant options (if any)
 * Params
 * @param {Object} activeProduct - active child product
 * @param {Object} children - Parent product's children map ({ "handle": {child-product-object} })
 */
var fetchVariantOptions = function fetchVariantOptions(handle) {
  var variantOptionsHTML = productData.children[handle].variant_options_html || false;

  if (variantOptionsHTML && isParentChild() || window.bvaccel.collection.quickviewHandle == handle) {
    $(_Dom2.default.pdpVariantOptionsEntry).html(variantOptionsHTML);
  }
};

var getProductOptionsCount = function getProductOptionsCount($context) {
  return $(_Dom2.default.pdpOptionsGroup, $context).length;
};

var updateATC = function updateATC(variant) {
  $(_Dom2.default.addToCart).attr('data-variant-id', variant.id);

  if (variant.available) {
    $(_Dom2.default.addToCart).removeClass('is-unavailable');
    $(_Dom2.default.addToCartText).text('Add To Cart');
  } else {
    $(_Dom2.default.addToCart).addClass('is-unavailable');
    $(_Dom2.default.addToCartText).text('Out of Stock');
  }
};

var updateBIS = function updateBIS(variant) {
  $(_Dom2.default.bis).addClass('u-hidden');
  $(_Dom2.default.addToCart).removeAttr('data-trigger-bis');
  $(_Dom2.default.bisVariantInput).attr('value', variant.id);
  if (!variant.available && !variant.unavailableCountry) {
    $(_Dom2.default.addToCart).attr('data-trigger-bis', true);
  }
};

var updatePrice = function () {
  var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(variant) {
    var variantPrice, variantComparePrice, localizedVariant, isEmpty, points, _ref2, _ref2$dataset, id;

    return _regenerator2.default.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            variantPrice = (0, _Helpers.formatMoney)(variant.price);
            variantComparePrice = (0, _Helpers.formatMoney)(variant.compare_at_price);

            if (!(Flow && Flow.getExperience())) {
              _context.next = 10;
              break;
            }

            localizedVariant = Flow.cache.localizedVariants.getById(variant.id);

            if (localizedVariant) {
              _context.next = 9;
              break;
            }

            console.log('Price not found in cache for variant ' + variant.id + ', loading...');
            _context.next = 8;
            return loadFlowForVariants([variant.id]);

          case 8:
            localizedVariant = Flow.cache.localizedVariants.getById(variant.id);

          case 9:
            if (localizedVariant) {
              variantPrice = localizedVariant.prices.item.label;
              variantComparePrice = $('[data-compare-price]').data('flow-compare-price');
            } else {
              console.log('ERROR: Price not found in cache for variant ' + variant.id);
            }

          case 10:

            $('[data-product-pricing] [data-price], [data-sticky-add-to-cart] [data-price]').html(variantPrice).attr('flow-default', (0, _Helpers.formatMoney)(variant.price)).attr('flow-variant', variant.id).attr('flow-variant-availability', variant.available ? 'InStock' : 'OutOfStock');

            isEmpty = function isEmpty(element) {
              return !$.trim(element.html());
            };

            isEmpty($('[data-compare-price]')) ? $('[data-product-pricing] [data-price]').removeClass('red') : $('[data-product-pricing] [data-price]').addClass('red');

            if (variant.compare_at_price === null) {
              $('[data-compare-price]').hide();
              $('[data-product-pricing] [data-price]').removeClass('red');
            } else {
              $('[data-compare-price]').html(variantComparePrice);
              $('[data-compare-price]').show();
              $('[data-product-pricing] [data-price]').addClass('red');
            }

            // Temp
            // if (window.Flow && window.Flow.hasOwnProperty('init')) {
            //   Flow.init();
            // }

            points = Math.floor(variant.price / 100);


            $(_Dom2.default.pdpSwellPoints).html(points);

            // assumes this is only happening on pdp template with main product container
            _ref2 = (0, _Helpers.getContainer)({ self: $('[data-product-main]')[0], type: 'product' }) || {}, _ref2$dataset = _ref2.dataset;
            _ref2$dataset = _ref2$dataset === undefined ? {} : _ref2$dataset;
            id = _ref2$dataset.containerId;

            PubSub.publish(_Constants2.default.updatePrice, { id: id, price: variant.price, compareAtPrice: variant.compare_at_price });

          case 20:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, undefined);
  }));

  return function updatePrice(_x) {
    return _ref.apply(this, arguments);
  };
}();

var updateLifeStylePhoto = function updateLifeStylePhoto(handle) {
  // Check if Product Type is Box
  if (productData.children[handle].data.type.includes('Box')) {
    return;
  }

  var lifeStyleImage = productData.children[handle].lifestyle_images;

  if (lifeStyleImage.length == 1) {
    $('[data-lifestyle-image]').html(lifeStyleImage).removeClass('empty');
  } else if (lifeStyleImage.length >= 2) {

    $('[data-lifestyle-image]').removeClass('empty').empty();

    $.each(lifeStyleImage, function (index, value) {
      $('[data-lifestyle-image]').append(value);
    });

    if ($('[data-lifestyle-image]').hasClass('slick-initialized')) {
      $('[data-lifestyle-image]').slick('unslick').empty();
      $.each(lifeStyleImage, function (index, value) {
        $('[data-lifestyle-image]').append(value);
      });
      $('[data-lifestyle-image]').slick();
    } else {
      $('[data-lifestyle-image]').slick();
    }
  } else {
    $('[data-lifestyle-image]').addClass('empty').empty();
  }
};

var updateZoom = function updateZoom() {
  var activeSlide = 'body .pdp-main .product-slider__slide.slick-active';

  $(activeSlide).trigger('zoom.destroy');
  var img_url = $('.pdp-main .product-slider__slide.slick-active').find('img').attr('src');

  if ($(window).width() > 767) {
    $(activeSlide).trigger('zoom.destroy');
    $(activeSlide).zoom({
      url: img_url,
      magnify: 1.1,
      on: 'click',
      target: $('.zoom-box'),
      onZoomIn: function onZoomIn() {
        $('.zoom-box').addClass('zoom-active');
      },
      onZoomOut: function onZoomOut() {
        $('.zoom-box').removeClass('zoom-active');
      }
    });
  } else {
    $(activeSlide).addClass('disabled');
    $(activeSlide).trigger('zoom.destroy');

    $(document).on('click', '.zoom-hover-icon.zoom-in-icon', function (e) {
      e.stopImmediatePropagation();
      if ($(activeSlide).hasClass('disabled')) {
        $('.zoom-hover-icon.zoom-out-icon.mobile').addClass('is-active');
        $(activeSlide).removeClass('disabled');
        $(activeSlide).zoom({
          url: img_url,
          magnify: 1.1,
          on: 'click',
          target: $('.zoom-box'),
          onZoomIn: function onZoomIn() {
            $('.zoom-box').addClass('zoom-active');
          },
          onZoomOut: function onZoomOut() {
            $('.zoom-box').removeClass('zoom-active');
          }
        });
      }
    });

    $(document).on('click', '.zoom-hover-icon.zoom-out-icon.mobile', function (e) {
      e.stopImmediatePropagation();
      if ($('.zoom-hover-icon.zoom-out-icon.mobile').hasClass('is-active')) {
        $(activeSlide).addClass('disabled');
        $('.zoom-hover-icon.zoom-out-icon.mobile').removeClass('is-active');
        $(activeSlide).trigger('zoom.destroy');
      }
    });
  }
};

var promoContent = function promoContent(classes, message) {
  return '<p class="' + classes + '">' + message + '</p>';
};

var updateSelectedOptionText = function updateSelectedOptionText(variant, handle) {
  updatePolarizedTitle(variant);

  // console.log('handle', handle);

  // if (handle === 'reveler-black-grey-lens-non-polarized' || handle === 'reveler-black-grey-lens-polarized' || handle === 'reveler-tortoise-green-lens-polarized' || handle === 'reveler-tortoise-green-lens-non-polarized') {
  //   $('[data-promo-content-entry]').empty().append(promoContent(`dy-promo-messanging-text`, `25% off with code <strong>DAD25</strong>`));
  // } else {
  //   $('[data-promo-content-entry]').empty();
  // }

  if (productData.children[handle].variant_option && productData.children[handle].variant_option.length >= 1) {
    $('[data-selected-value="0"]').html(productData.children[handle].variant_option);
    $('[data-option-value]').removeClass('is-active');
    $('[data-option-value=\'' + productData.children[handle].variant_option + '\']').addClass('is-active');
  } else {
    variant.options.forEach(function (option, index) {
      var optionGroup = $('[data-option-group]').eq(index);

      optionGroup.find('[data-option-value]').removeClass('is-active');
      optionGroup.find('[data-option-value=\'' + option + '\']').addClass('is-active');
      $('[data-selected-value="' + index + '"]').html(option);
    });

    if ($('[data-option-value="Non-Polarized"]').hasClass('is-active')) {
      $('[data-option-group="polarization"]').find('.product-options__tooltip-container').css('display', 'none');
    } else {
      $('[data-option-group="polarization"]').find('.product-options__tooltip-container').css('display', 'block');
    }
  }
};

var updateAvailableOptions = function updateAvailableOptions(variant) {
  var childProductVariants = [];

  Object.keys(productData.children).forEach(function (productHandle) {
    if (!productData.children[productHandle].is_hidden) {
      productData.children[productHandle].data.variants.forEach(function (variant) {
        return childProductVariants.push(variant);
      });
    }
  });

  $.each(productData.product.options, function (option_index, option) {
    var other_options = Object.keys(productData.product.options).filter(function (option) {
      return option != String(option_index);
    });
    var filtered_instock_variants = childProductVariants.filter(function (product_variant) {
      for (var i = 0; i < other_options.length; i++) {
        if (variant.options[other_options[i]] != product_variant.options[other_options[i]]) {
          return false;
        }
      }
      return true;
    }).map(function (product_variant) {
      return product_variant.options[option_index];
    });

    $('[data-cv="' + filtered_instock_variants + '"]');

    $('[data-product-option-index="' + option_index + '"] li').show().removeClass('disabled').each(function (index, element) {
      var elem = $(element);
      var elem_value = elem.find('button').data('option-value');

      if (filtered_instock_variants.indexOf(elem_value) == -1) {
        if (option_index !== 0) {
          elem.addClass('disabled');
        }
      }
    });
  });
};

var updateProductOptions = function updateProductOptions(handle) {
  var $optionsContext = $('.product-right').find(_Dom2.default.pdpOptions);
  var $ProductOptions = $(_Dom2.default.pdpOptionValue, $optionsContext);
  var handlePrefix = $optionsContext.attr('data-product-options');
  var productHandles = Object.keys(productData.children);

  var activeFirst = '';
  var handleIndex = 0;

  if (!isParentChild()) {
    return productData.product.handle;
  }

  if ($('[data-option-group]').length == 1) {
    $(_Dom2.default.pdpOption).each(function (i) {
      var activeHandle = handlePrefix + '-' + $(this).data('value');
    });
  } else if ($('[data-option-group]').length == 2) {
    $('[data-option-group]').each(function (index) {
      var optionValues = $(this).find(_Dom2.default.pdpOption);

      if (index == 0) {
        activeFirst = $(this).find(_Dom2.default.pdpOption + '.is-active');
      }

      optionValues.each(function (i) {

        var activeHandle = handlePrefix + '-' + activeFirst.data('value') + '-' + $(this).data('value');

        if (!productData.children[activeHandle]) {
          // $(`[data-option-group="${$(this).data('option')}"]:nth-child(3) [data-value='${$(this).data('value')}']`).css('opacity', '0')
        } else {
            // $(`[data-option-group="${$(this).data('option')}"]:nth-child(3) [data-value='${$(this).data('value')}']`).css('opacity', '1')
          }

        handleIndex++;
      });
    });
  }
};

var updateSpecsDetails = function updateSpecsDetails(handle) {
  var currentHandle = getCurrentProductHandle();

  if (currentHandle !== handle) {
    if (productData.specs_details_ready) {
      var specsDetailsHTML = productData.children[handle].specs_details_html;

      $('[data-product-detail-tabs]').html(specsDetailsHTML);
      // update yotpo reviews
      yotpo.initWidgets();
      _SizeGuide2.default.init();
      updateLifeStylePhoto(handle);
    }
  }
};

var updatePolarizedTitle = function updatePolarizedTitle(variant) {
  variant.option2 == 'Polarized' ? $('.product-name span').html(variant.option2) : $('.product-name span').empty();
};

var updateProductDescription = function updateProductDescription(handle) {
  if (productData.children[handle].product_description && productData.children[handle].product_description.length >= 1) {
    $('.pdp-description').html(productData.children[handle].product_description);
  }
};

var updateVariant = function updateVariant(optionIndex, value) {
  var handle = getCurrentProductHandle();
  var product = productData.children[handle].data;
  var variant = product.variants.reduce(function (selectedVariant, variant) {
    if (variant.options[optionIndex] == value) {
      selectedVariant = variant;
    }
    return selectedVariant;
  }, false);

  updateProduct(handle, variant);
};

var getVariant = function getVariant(optionIndex, value, handle) {
  var product = productData.children[handle].data;
  var variant = product.variants.reduce(function (selectedVariant, variant) {
    if (variant.options[optionIndex] == value) {
      selectedVariant = variant;
    }
    return selectedVariant;
  }, false);

  return variant;
};

var initProductGallery = exports.initProductGallery = function initProductGallery() {
  $(_Dom2.default.pdpImageGallery).on('init reInit', function () {
    if (productData) {
      var handle = getCurrentProductHandle();
      var $dots = $(_Dom2.default.pdpImageGallery).find('.slick-dots');
      var $thumb = $dots.find('[data-product-see-style]');

      if (productData.children[handle]
      // &&  $thumb.length
      && productData.children[handle].style_thumb
      // && !productData.children[handle].style_thumb.length
      && !window.bvaccel.product.quickViewOpen) {
        $dots.append(productData.children[handle].style_thumb);
      }
    }
  });

  $(_Dom2.default.pdpImageGallery).on('init afterChange', function (event, slick, currentSlide) {
    var $slide = $(slick.$slides[currentSlide]);
    var isVideo = $slide.data('video') || false;

    if (isVideo) {
      // video is global so that it can be paused at any time
      video = $slide.find(_Dom2.default.pdpVideo).get(0);
      video.play();
    } else if (video) {
      video.pause();
    }

    updateZoom();
  });

  $(_Dom2.default.pdpImageGallery).slick({
    rows: 0,
    dots: true,
    fade: true,
    arrows: true,
    mobileFirst: true,
    // adaptiveHeight: true,
    nextArrow: '<button class="slick-next slick-arrow" aria-label="go to next slide" type="button"><svg class="slick-arrow__icon" width="9" height="14" viewBox="0 0 9 14" xmlns="http://www.w3.org/2000/svg"><path d="M1.6855 0L0 1.63333 5.53808 7 0 12.36667 1.6855 14l7.22359-7z" fill="#2B2B2B" fill-rule="evenodd"/></svg></button>',
    prevArrow: '<button class="slick-prev slick-arrow" aria-label="go to previous slide" type="button"><svg class="slick-arrow__icon" width="9" height="14" viewBox="0 0 9 14" xmlns="http://www.w3.org/2000/svg"><path d="M7.22359 0l1.6855 1.63333L3.37101 7l5.53808 5.36667L7.22359 14l-7.2236-7z" fill="#2B2B2B" fill-rule="evenodd"/></svg></button>',
    customPaging: function customPaging(slider, i) {
      var isVideo = $(slider.$slides[i]).data('video') || false;
      var videoBtn = isVideo ? '<div class="button button--video"></div>' : '';

      return '<button type="button" aria-label="Navigate to image #' + i + '" class="product-slider__nav-item"><img src="' + $(slider.$slides[i]).data('thumb') + '" alt="image #' + i + ' thumbnail" srcset="' + $(slider.$slides[i]).data('thumb-srcset') + '" />' + videoBtn + '</button>';
    },
    responsive: [{
      breakoint: 768,
      settings: {
        fade: true,
        arrows: false,
        draggable: false,
        adaptiveHeight: false
      }
    }]
  });
};

var getCurrentProductHandle = exports.getCurrentProductHandle = function getCurrentProductHandle() {
  var url = window.location.pathname.split('/');
  var handle = url.pop();

  if (window.bvaccel.collection.quickviewHandle) {
    return window.bvaccel.collection.quickviewHandle;
  }

  if (productData) {
    if (!isParentChild()) {
      return productData.product.handle;
    }
    if (handle == productData.product.handle) {
      for (var childProductHandle in productData.children) {
        if (productData.children.hasOwnProperty(childProductHandle) && !productData.children[childProductHandle].is_hidden) {
          return productData.children[childProductHandle].data.handle;
        }
      }
    }
  }
  return handle;
};

var addAllSlides = exports.addAllSlides = function addAllSlides() {
  var handle = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : getCurrentProductHandle();

  productData.children_handles.forEach(function (child_handle) {
    if (child_handle !== handle && productData.children[child_handle] && !productData.children[child_handle].is_hidden) {
      var imageHTMLArray = productData.children[child_handle].images;

      for (var i = 0; i < imageHTMLArray.length; i++) {
        $(_Dom2.default.pdpImageGallery).slick('slickAdd', imageHTMLArray[i]);
      }
    }
  });
};

var checkHandle = exports.checkHandle = function checkHandle(handle, activeOptionValues, $optionsContext) {
  var children_handles = Object.keys(productData.children);
  var newHandle = children_handles[0];

  if (children_handles.includes(handle)) return handle;

  children_handles.forEach(function (childHandle) {
    var child = productData.children[childHandle];

    if (!child.is_hidden) {
      child.data.variants.forEach(function (childVariant, childVariantIndex) {
        if (childVariant.option1 == activeOptionValues[0]) {
          newHandle = childHandle;

          // $optionsContext.find('.product-options__value').removeClass('is-active');

          ['option1', 'option2', 'option3'].forEach(function (option, index) {
            var $optionSwatch = $optionsContext.find('.product-options__value[data-option-value="' + childVariant[option] + '"]');

            if ($optionSwatch.length) {
              var name = $optionSwatch.data('name');
              var value = $optionSwatch.data('value');
              var container = (0, _Helpers.getContainer)({ self: $optionSwatch[0], type: 'product' });
              var id = container.dataset.containerId;

              var ms = index * 150;

              setTimeout(function () {
                PubSub.publish(_Constants2.default.optionValueChange, { id: id, name: name, value: value });
              }, ms);

              // $optionSwatch.addClass('is-active');
            }
          });
        }
      });
    }
  });

  return newHandle;
};

var updateProduct = exports.updateProduct = function updateProduct() {
  var handle = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : getCurrentProductHandle();
  var selectedVariant = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

  var variant = selectedVariant ? selectedVariant : productData.children[handle].data.variants[0];

  updateATC(variant);
  // updateBIS(variant);
  updatePrice(variant);
  updateLifeStylePhoto(handle);

  updateSelectedOptionText(variant, handle);
  updateAvailableOptions(variant);
  updateProductOptions();
  updatePolarizedTitle(variant);
  updateSpecsDetails(handle);
  updateProductDescription(handle);
  filterSlider(handle);
  updateBuyBarSelected(variant);
  initProductUpsellData().then(function () {
    return initUpsells(handle);
  });
  _SeeItStyled2.default.update(handle);
  if (!selectedVariant) {
    fetchVariantOptions(handle);
  }

  updateZoom();
  $(window).resize(function () {
    updateZoom();
  });

  // Keep last
  if (!window.bvaccel.collection.quickviewHandle) {
    // if pdp
    updateUrlHistory(handle);
  } else {
    // if quickview
    window.bvaccel.collection.quickviewHandle = handle;
  }
};

var getProductData = exports.getProductData = function getProductData(handle) {
  var url = '/products/' + handle + '/?view=json';

  return fetch(url, HTTP_OPTIONS).then(function (res) {
    return res.text();
  }).then(function (res) {
    return JSON.parse(res);
  }).catch(function (err) {
    console.log('JSON Fetch Error', err);
  });
};

var getProductUpsellsData = exports.getProductUpsellsData = function () {
  var _ref3 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee2(handle) {
    var url;
    return _regenerator2.default.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            url = '/products/' + handle + '/?view=ajax-upsells';
            _context2.next = 3;
            return fetch(url).then(function (res) {
              return res.text();
            }).then(function (res) {
              return res;
            }).catch(function (err) {
              console.log('AJAX Fetch Error', err);
            });

          case 3:
            return _context2.abrupt('return', _context2.sent);

          case 4:
          case 'end':
            return _context2.stop();
        }
      }
    }, _callee2, undefined);
  }));

  return function getProductUpsellsData(_x5) {
    return _ref3.apply(this, arguments);
  };
}();

var getProductSpecsDetailsData = exports.getProductSpecsDetailsData = function () {
  var _ref4 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee3(handle) {
    var url;
    return _regenerator2.default.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            url = '/products/' + handle + '/?view=ajax-specs-details';
            _context3.next = 3;
            return fetch(url).then(function (res) {
              return res.text();
            }).then(function (res) {
              return res;
            }).catch(function (err) {
              console.log('AJAX Fetch Error', err);
            });

          case 3:
            return _context3.abrupt('return', _context3.sent);

          case 4:
          case 'end':
            return _context3.stop();
        }
      }
    }, _callee3, undefined);
  }));

  return function getProductSpecsDetailsData(_x6) {
    return _ref4.apply(this, arguments);
  };
}();

var initProductData = exports.initProductData = function initProductData() {
  var handle = getCurrentProductHandle();

  return getProductData(handle).then(function (res) {
    return exports.productData = productData = res;
  });
};

// export const initProductAvailability = async () => {
//   console.log('productData', productData);

//   const variantIds = [];

//   Object.keys(productData.children).forEach(function (childHandle) {
//     productData.children[childHandle].data.variants.forEach(childVariant => {
//       variantIds.push(childVariant.id);
//     });
//   });
//   const json = await ProductAvailability.getInventories(variantIds);

//   if (json && json.inventory) {

//     Object.keys(productData.children).forEach(function (childHandle) {
//       const childVariants = productData.children[childHandle].data.variants;

//       childVariants.forEach((childVariant, childVariantIndex) => {
//         const inventory = json.inventory.find(inventory => inventory.variant_id == childVariant.id);

//         if (inventory && inventory.available <= 0) {
//           childVariants[childVariantIndex].available = false;
//           childVariants[childVariantIndex].unavailableCountry = true;
//         }
//       });
//     });
//   }
// };

var initFlowData = exports.initFlowData = function initFlowData() {
  return new Promise(function (resolve) {
    if (Flow && window.Flow.getExperience && Flow.getExperience() && Flow.variants) {
      Flow.variants.loadByHandles({
        handles: Object.keys(productData.children),
        success: function success(status, variants) {
          resolve(status);
        }
      });
    } else {
      resolve();
    }
  });
};

var loadFlowForVariants = exports.loadFlowForVariants = function () {
  var _ref5 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee4(variantIds) {
    return _regenerator2.default.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            return _context4.abrupt('return', new Promise(function (resolve) {
              if (Flow && Flow.getExperience()) {
                Flow.variants.load({
                  variants: variantIds,
                  success: function success(status, variants) {
                    resolve(status);
                  }
                });
              } else {
                resolve();
              }
            }));

          case 1:
          case 'end':
            return _context4.stop();
        }
      }
    }, _callee4, undefined);
  }));

  return function loadFlowForVariants(_x7) {
    return _ref5.apply(this, arguments);
  };
}();

var initProductUpsellData = exports.initProductUpsellData = function () {
  var _ref6 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee5() {
    return _regenerator2.default.wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            if (!(productData.children_handles.length = 1)) {
              _context5.next = 2;
              break;
            }

            return _context5.abrupt('return', getProductUpsellsData(productData.product.handle).then(function (res) {
              return productData.upsells_ready = true, productData.children[productData.children_handles[0]].upsells_html = res;
            }));

          case 2:
            return _context5.abrupt('return', Promise.all(productData.children_handles.map(function (handle, index) {
              return getProductUpsellsData(handle).then(function (res) {
                return productData.upsells_ready = true, productData.children[handle].upsells_html = res;
              });
            })));

          case 3:
          case 'end':
            return _context5.stop();
        }
      }
    }, _callee5, undefined);
  }));

  return function initProductUpsellData() {
    return _ref6.apply(this, arguments);
  };
}();

var initProductSpecsDetails = exports.initProductSpecsDetails = function () {
  var _ref7 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee6() {
    var productHandles;
    return _regenerator2.default.wrap(function _callee6$(_context6) {
      while (1) {
        switch (_context6.prev = _context6.next) {
          case 0:
            productHandles = Object.keys(productData.children);
            return _context6.abrupt('return', Promise.all(productHandles.map(function (handle, index) {
              return getProductSpecsDetailsData(handle).then(function (res) {
                return productData.specs_details_ready = true, productData.children[handle].specs_details_html = res;
              });
            })));

          case 2:
          case 'end':
            return _context6.stop();
        }
      }
    }, _callee6, undefined);
  }));

  return function initProductSpecsDetails() {
    return _ref7.apply(this, arguments);
  };
}();

var updateBuyBarSelected = exports.updateBuyBarSelected = function updateBuyBarSelected(variant) {
  updateBuyBarSelected.titleSelector = updateBuyBarSelected.titleSelector || new _DataSelector2.default('data-desktop-sticky-atc-bar-selected');
  updateBuyBarSelected.titleElement = updateBuyBarSelected.titleElement || updateBuyBarSelected.titleSelector.node();
  var template = window.bvaccel.template.path;

  var selectedText = '';

  if (!variant || !productData) {
    return console.error('Cannot set buy bar title. Variant or productData undefined.');
  }

  // idk if this is necessary...
  // const tagVariantOptions = productData.product.tags
  //   .filter(t => /size-this::/.test(t))
  //   .map(t => t.split('::'))
  //   .map(t => t[1] + 'mm');

  var variantOptionString = variant.options.map(function (op) {
    return op.toLowerCase();
  }).filter(function (op) {
    return op !== 'default title';
  }).reduce(function (acc, op) {
    return acc + ' - ' + op;
  }, '');

  selectedText = productData.product.title + variantOptionString;
  updateBuyBarSelected.titleElement.innerText = selectedText;
};

var disableLoader = exports.disableLoader = function disableLoader() {
  var _ACTIVE_CLASS = 'pdp-loader--active';
  var _selector = new _DataSelector2.default('data-pdp-loader');
  var _loader = _selector.node();
  var setZ = function setZ() {
    return _loader.style.zIndex = '-1';
  };

  _loader.classList.remove(_ACTIVE_CLASS);
  if ('ontransitionend' in window) {
    _loader.addEventListener('transitionend', setZ);
  } else {
    setZ();
  }
};

/**
 * @param timeout {Number} ms
 */
var setLoaderTimeout = exports.setLoaderTimeout = function setLoaderTimeout() {
  var timeout = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 7500;

  window.setTimeout(disableLoader, timeout);
};

exports.default = {
  initProductGallery: initProductGallery,
  getProductData: getProductData,
  updateUrlHistory: updateUrlHistory,
  getProductOptionsCount: getProductOptionsCount,
  checkHandle: checkHandle,
  updateProduct: updateProduct,
  getSlickOption: getSlickOption,
  getVariant: getVariant,
  updateVariant: updateVariant,
  updateATC: updateATC
};